import { openWebview, useFormatPrice } from '@docs/common'
import useLanguageTrans from 'common/useLanguageTrans'
import Modal from '@docs/common/components/Modal'
import { PopCoupon } from 'pages/Recommend/ArticleBase/VariantItem'
import moment from 'moment'
import { useTranslation } from '@volcengine/i18n'
import React, { useEffect, useState } from 'react'
import { CopyToClipboard } from 'react-copy-to-clipboard'
import styles from './styles.module.scss'
import { getMallDomain } from 'common/util'

type Props = {
  popupCoupon?: PopCoupon
}

const ReceivedPop: React.FC<Props> = ({ popupCoupon }) => {
  const formatPrice = useFormatPrice()
  useLanguageTrans()
  const { t } = useTranslation()

  const [visible, setVisible] = useState(true)

  // 渲染优惠券折扣
  const renderDiscount = () => {
    return popupCoupon?.value_type === 'fixed_amount'
      ? formatPrice(Math.abs(Number(popupCoupon.value)))
      : `${Math.abs(Number(popupCoupon?.value))}%`
  }

  // 关闭弹窗
  const handleClose = () => {
    setVisible(false)
  }
  // 复制成功
  const handleCopyEnd = () => {
    handleClose()
    setTimeout(async () => {
      openWebview(`${await getMallDomain()}/products/variant/${popupCoupon?.handle}/${popupCoupon?.sku}`)
    })
  }
  // 打开我的优惠券
  const openMyCoupons = async () => {
    openWebview(`${await getMallDomain()}/n/coupon/list`)
  }
  useEffect(() => {
    setVisible(!!popupCoupon?.code)
  }, [popupCoupon])

  if (!popupCoupon) {
    return null
  }
  return (
    <Modal visible={visible} className={styles.modalWrap}>
      <div className={styles.modalContent}>
        <div className={styles.topHandle}>
          <i onClick={() => handleClose()}></i>
          <span>{t('rec_coupon_pop_title')}</span>
        </div>
        <div className={styles.innerContent}>
          <div className={styles.couponBox}>
            <div className={styles.discount}>
              {renderDiscount()}
              <div>{t('common_discount')}</div>
            </div>
            <div className={styles.split}>
              <span></span>
            </div>
            <div className={styles.discountInfo}>
              <div className={styles.summary}>{popupCoupon?.summary?.split('off ')[1]}</div>
              <div className={styles.valid}>
                {t('rec_valid_until')}
                <span>{moment.unix(popupCoupon?.expire_at!).format('MM/DD/YYYY')}</span>
              </div>
            </div>
          </div>
          <CopyToClipboard onCopy={handleCopyEnd} text={`${popupCoupon?.code}`}>
            <span className={styles.copyBtn}>{t('rec_save_coupon')}</span>
          </CopyToClipboard>
          <span  className={styles.link} onClick={openMyCoupons}>
            {t('rec_check_coupon_link')}
          </span>
        </div>
      </div>
    </Modal>
  )
}

export default ReceivedPop
